import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

const Footer = ({ t }) => {
  const location = useLocation();

  // Kiolvassuk az első szegmenst az URL-ből (pl. "en", "hu", "de")
  const lang = location.pathname.split("/")[1];

  return (
    <footer className="footer  mt-4 py-1">
      <div className="w-100 px-0">
        {/* 1. sor: Név + social ikonok */}
        <div className="row align-items-center my-4">
          <div className="col-md-6 text-md-start text-center ps-4 mb-2 mb-md-0">
            <h5 className="mb-0 fw-bold footer-Brand">
              Csillag masszázs Pedikűr
            </h5>
          </div>
          <div className="col-md-6 text-md-end text-center">
            <ul className="list-inline mb-0">
              <li className="list-inline-item mx-2 social-media">
                <a
                  href="https://www.facebook.com/profile.php?id=61551742774521"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="fa fa-facebook"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href="https://twitter.com" target="_blank" rel="noreferrer">
                  <span className="fa fa-twitter"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="fa fa-instagram"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                  <span className="fa fa-linkedin"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href="mailto:eszter.janos81@gmail.com?subject=Kérdés%20a%20szolgáltatásokkal%20kapcsolatban&body=Kedves%20Eszter,%0D%0A%0D%0AÉrdeklődöm%20a%20szolgáltatások%20iránt.%20Szeretnék%20több%20információt%20kapni%20a%20következő%20témában:%0D%0A%0D%0A[Írd%20be%20ide%20a%20kérdéseidet%20vagy%20megjegyzéseidet]%0D%0A%0D%0AÜdvüzlettel,%0D%0AJános%20Eszter">
                  <span className="fa fa-envelope"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 2. sor: Navigációs linkek */}
        <div className="row mb-3">
          <div className="col text-center">
            <div className="footer-links">
              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/archive`}
              >
                {t("archive")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/PrivacyPolicy`}
              >
                {t("policy")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/TermsOfUse`}
              >
                {t("terms")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/CookiePolicy`}
              >
                {t("cookie")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/Imprint`}
              >
                {t("imprint")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/media`}
              >
                {t("media")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/Contact`}
              >
                {t("contact")}
              </NavLink>
            </div>
          </div>
        </div>

        {/* 3. sor: Copyright */}
        <div className="row">
          <div className="col text-center">
            <p className="footer-copyright mb-0">
              © 2025 Csillag Masszázs Pedikűr. {t("copyright")}.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default withTranslation()(Footer);
